import {
  NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation,
  NotifyGovWellSalesTeamAboutAdditionalUseCaseMutationVariables,
  NotifyGovWellSalesTeamAboutAIAssistantMutation,
  NotifyGovWellSalesTeamAboutAIAssistantMutationVariables,
  NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation,
  NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutationVariables,
} from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const NotifyGovWellSalesTeamAboutAIAssistant = gql`
  mutation NotifyGovWellSalesTeamAboutAIAssistantMutation {
    notifyGovWellSalesTeamAboutAIAssistant
  }
`

export const useNotifyGovWellSalesTeamAboutAIAssistant = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutAIAssistantMutation,
    NotifyGovWellSalesTeamAboutAIAssistantMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutAIAssistant,
  })
}

const NotifyGovWellSalesTeamAboutAdditionalUseCase = gql`
  mutation NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation(
    $useCase: String!
    $additionalInformation: String!
  ) {
    notifyGovWellSalesTeamAboutAdditionalUseCase(
      useCase: $useCase
      additionalInformation: $additionalInformation
    )
  }
`

export const useNotifyGovWellSalesTeamAboutAdditionalUseCase = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation,
    NotifyGovWellSalesTeamAboutAdditionalUseCaseMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutAdditionalUseCase,
  })
}

const NotifyGovWellSalesTeamAboutHigherAIAssistantTier = gql`
  mutation NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation($tier: String!) {
    notifyGovWellSalesTeamAboutHigherAIAssistantTier(tier: $tier)
  }
`

export const useNotifyGovWellSalesTeamAboutHigherAIAssistantTier = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation,
    NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutHigherAIAssistantTier,
  })
}
